import _ from 'lodash'

const importLegacyReducers = (r) => {
  const files = {}
  r.keys().forEach((key) => {
    const reducerName = _.camelCase(key.replace(/(^.\/|.js$)/g, ''))
    files[reducerName] = r(key).default
  })
  return files
}

const importAllReducers = (r) => {
  const reducers = {}

  r.keys().forEach((key) => {
    const { reducer, name } = r(key)

    if (!name) {
      return
    }

    reducers[name] = reducer
  })

  return reducers
}

const importAllServices = (r) => {
  const reducers = {}
  const middlewares = []

  r.keys().forEach((key) => {
    const api = r(key).default

    if (!api) {
      return
    }

    reducers[api.reducerPath] = api.reducer
    middlewares.push(api.middleware)
  })

  return {
    reducers,
    middlewares
  }
}

export const getLegacyReducers = () => {
  return importLegacyReducers(require.context('./reducers', false, /\.js$/))
}

export const getReducers = () => {
  return importAllReducers(require.context('./b/slices', false, /\.js$/))
}

export const getServices = () => {
  const allReducers = {}
  const allMiddlewares = []

  const deepServices = importAllServices(require.context('./b', true, /\.service.js$/))
  Object.assign(allReducers, deepServices.reducers)
  allMiddlewares.push(...deepServices.middlewares)

  const directServices = importAllServices(require.context('./b/services', false, /\.js$/))
  Object.assign(allReducers, directServices.reducers)
  allMiddlewares.push(...directServices.middlewares)

  return {
    reducers: allReducers,
    middlewares: allMiddlewares
  }
}

export default {
  getLegacyReducers,
  getReducers,
  getServices
}
